import React from 'react';

const ChunkLoadErrorMobileRefreshIcon = () => {
  return (
    (<svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-palette="ChunkLoadErrorMobileRefreshIcon">
      <path
        d="M7.38121 5.23543C11.1615 1.95972 15.9978 0.159698 21 0.166677C32.5062 0.166677 41.8333 9.49376 41.8333 21C41.8333 25.45 40.4375 29.575 38.0625 32.9584L31.4166 21H37.6666C37.6669 17.7326 36.7067 14.5371 34.9055 11.811C33.1043 9.08482 30.5415 6.94826 27.5357 5.66694C24.53 4.38561 21.2139 4.01606 17.9999 4.60422C14.7858 5.19237 11.8155 6.7123 9.45829 8.97501L7.38121 5.23543ZM34.6187 36.7646C30.8384 40.0403 26.0021 41.8403 21 41.8334C9.49371 41.8334 0.166626 32.5063 0.166626 21C0.166626 16.55 1.56246 12.425 3.93746 9.04168L10.5833 21H4.33329C4.33302 24.2675 5.29319 27.4629 7.09441 30.1891C8.89563 32.9152 11.4584 35.0518 14.4642 36.3331C17.4699 37.6144 20.786 37.984 24 37.3958C27.2141 36.8077 30.1844 35.2877 32.5416 33.025L34.6187 36.7646Z"
        fill="#00BD84"
      />
    </svg>)
  );
};

export default ChunkLoadErrorMobileRefreshIcon;
